import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { createCategory } from "../../../actions/roblox/categoriesActions";
import { setNewParams, setNewError } from "../../../store/roblox/categoriesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.roblox.categories.newParams);
  const error     = useAppSelector(state => state.roblox.categories.newError);

  let params: any = { ...newParams };

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: object) {
    const rules     = {};
    const formData  = objToFormData(data, rules);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createCategory(data));

    if (createCategory.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-skin'>
        <h6 className="v-content-label">Create Category</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
